import React from 'react';

import './style.styl';

interface IProps {
  loading: boolean;
}

class LoadingSlider extends React.Component<IProps> {
  static defaultProps = {
    loading: false
  };

  render() {
    let { loading, children } = this.props;

    if (!loading) {
      return <React.Fragment>{children}</React.Fragment>;
    }

    return (
      <div className="loading-progress-bar">
        <div className="progress-bar-slider" />
      </div>
    );
  }
}

export default LoadingSlider;
